import './library/foundation';

import {
	animationGalleryHoverEffect,
	animationGalleryRevealEffect,
	animationShowButtonOnScroll,
	animationEnterHero,
	animationIntroductionEffect,
	animationKeyFiguresCounter,
	animationCardsEffect,
	animationFeaturedLink,
	animationHomeAboutEffect,
	animationManagingContentEffect,
	animationManagingFooterEffect,
	animationContactFormEffect,
	animationMediaRevealEffect,
	animationEmbedRevealEffect
} from './animations';

import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faEnvelope, faPhone, faArrowUp, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faTwitter, faViadeo } from '@fortawesome/free-brands-svg-icons';
import { faChevronRight as chevronRight } from '@fortawesome/pro-regular-svg-icons'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

document.documentElement.className = "js"

library.add(faMapMarkerAlt, faLinkedin, faChevronRight, faEnvelope, faPhone, faTwitter, faViadeo, faArrowUp, chevronRight);

dom.i2svg();

$(document).foundation();

const init = () => {
	ScrollTrigger.config({ limitCallbacks: true });

	animationShowButtonOnScroll();
	animationEnterHero();
	animationIntroductionEffect();
	animationKeyFiguresCounter();
	animationCardsEffect();
	animationFeaturedLink();
	animationMediaRevealEffect();
	animationEmbedRevealEffect();
	
	if (document.body.classList.contains('home')) {
		animationHomeAboutEffect();
	} else if (document.body.classList.contains('page-managing') || document.body.classList.contains('page-managing-en')) {
		animationGalleryRevealEffect();
		animationGalleryHoverEffect();
		animationManagingContentEffect();
		animationManagingFooterEffect();
	} else if (document.body.classList.contains('page-contact') || document.body.classList.contains('page-contact-us')) {
		animationContactFormEffect();
	}
}

// /* *
//  * SCROLL MAGIC BUILDER
//  */
// const scrollMagicBuild = () => {
// 	let controller = new ScrollMagic.Controller();

// 	//HOME SOCIAL WALL
// 	if (document.querySelector('.social-wall-container')) {
// 		let socialWall = document.querySelector('.social-wall-container'),
// 			length = +100,
// 			duration = 1,
// 			delay = 1.2,
// 			offset = 50;

// 		// build tween
// 		let tween = TweenMax.from(socialWall, duration, {
// 			delay: delay,
// 			y: length,
// 			autoAlpha: 0,
// 			ease: Power4.easeOut,
// 		});

// 		// build scene
// 		let scene = new ScrollMagic.Scene({
// 			triggerElement: socialWall,
// 			triggerHook: 'onEnter',
// 			offset: offset,
// 			reverse: false,
// 		})
// 			.setTween(tween)
// 			//.addIndicators({name: "Intro"}) // add indicators (requires plugin)
// 			.addTo(controller);
// 	}

// 	/**
// 	 * ARCHIVE PAGES
// 	 */

// 	// ARCHIVE GRID
// 	if (document.querySelectorAll('.archive-grid-content')) {
// 		let archiveGrid = document.querySelectorAll('.archive-grid-content');

// 		[].forEach.call(archiveGrid, function (element) {
// 			// set variables
// 			let length = +50,
// 				duration = 0.6;

// 			// build tween
// 			let tween = TweenMax.from(element, duration, {
// 				y: length,
// 				autoAlpha: 0,
// 				ease: Linear.easeNone,
// 			});

// 			// build scene
// 			let scene = new ScrollMagic.Scene({
// 				triggerElement: element,
// 				triggerHook: 'onEnter',
// 				reverse: false,
// 			})
// 				.setTween(tween)
// 				//.addIndicators( {name: "Archive Grid " + (i + 1)} ) // add indicators (requires plugin)
// 				.addTo(controller);
// 		});
// 	}
// };

document.addEventListener('DOMContentLoaded', function () {
	init();
});
